import { RetryLink } from '@apollo/client/link/retry';

/**
 * Retries network-level failures only (never GraphQL business errors) with exponential backoff,
 * capped at 3 attempts — matching the backend's own retry philosophy for notification sends
 * (docs/business/BusinessRules.md Notifications rule #3), so both halves of the system fail in a
 * consistent, bounded way (docs/development/FrontendGuidelines.md §9.5).
 */
export const retryLink = new RetryLink({
  delay: {
    initial: 300,
    max: 3000,
    jitter: true,
  },
  attempts: {
    max: 3,
    retryIf: (error) => Boolean(error),
  },
});
